export default {
// module.exports = {
  // NODE_ENV: 'production',
  // 测试
  WECHAT_CORPID_DEV: 'wx521922227e01c0ed',
  MONTHSUMMARY_APPID_DEV: '1000006',
  WECHAT_CORPSECRET_DEV: 'G1YRACaL5zFf7Pth1Yg3KaI-cJpYHOWycsivyzj60Y-7dNBpwbGjfYVayKcEJoaH',
  // 正式
  WECHAT_CORPID_PROD: 'wx7dca6b7323e4f055',
  MONTHSUMMARY_APPID_PROD: '1000027',
  WECHAT_CORPSECRET_PROD: 'CJ-t48ji9dDo7WF_xl72Iy2deXU7sfIHoOCraf_Cj0g',
  
  // 主机地址
  LOCALHOST_LOCAL: 'localhost' || '192.168.1.93',
  LOCALHOST_DEV: 'ehr-wechat-vue.efckudu.lunztech.cn',
  LOCALHOST_FAT: 'ehr-wechat-vue-test.zhongruigroup.com',
  LOCALHOST_FAT_OLD: 'ehr-wechat-vue.lunztech.cn',
  LOCALHOST_LIVE: 'ehr-wechat-vue.efckudu.lunz.cn',
  LOCALHOST_PROD: 'ehr-wechat-vue.zhongruigroup.com',
  LOCALHOST_PROD_OLD: 'ehr-wechat-vue.lunz.cn',

  API_PATH_LOCAL: '//localhost:6811/api/',
  API_PATH_DEV: '//ehr-api.lunztech.cn/api/',
  API_PATH_LIVE: '//ehr-api.kuduhz2018.lunz.cn/api/',
  API_PATH_LIVENEW: '//ehr-api.ehrkudu.lunz.cn/api/',
  API_PATH_PROD: '//ehr-api.lunz.cn/api/',
  APPKEY_DEV: 'f8a08fa2-a3bd-4223-b942-af407d993ef0',
  // 正式
  APPKEY_LIVE: 'f8a08fa2-a3bd-4223-b942-af407d993ef0',
  APPKEY_PROD: 'f8a08fa2-a3bd-4223-b942-af407d993ef0',
  SCRM_PATH_HOST: '//scrm2018-api.lunz.cn/api/',
  SCRM_PATH_KEY: '13095435-444a-11e8-b235-7cd30abc9af2',
  DATA_CENTER_APPKEY_DEV: 'd861fd58-7720-4ac7-b45a-9fabb6dc509d',
  DATA_CENTER_APPKEY_PROD: '536babcc-dd54-42fb-b43e-31c80b7afa74',
  DATA_CENTER_API_PATH_DEV: '//datacenter.lunztech.cn/api/',
  DATA_CENTER_API_PATH_PROD: '//datacenter.lunz.cn/api/',
  DATA_CENTER_API_PATH_HOST: '//datacenter.lunz.cn/',
  USER_CENTER_APPKEY: 'e89c3b28-4539-4efc-82ad-886c35e2050c',
  USER_CENTER_API_PATH_HOST: '//usercenter2015.lunztech.cn/',

  WECHAT_BINDURL_DEV: 'http://ehr-wechat.lunztech.cn/WeChat/BindWeChat?backUrl=',
  WECHAT_BINDURL_PROD: 'http://ehr-wechat.lunz.cn/WeChat/BindWeChat?backUrl=',

  //ID配置
  HighestEducationTypeId: '2E48E285-1038-4547-A570-353A3F17437A', // 学历类型
  SchoolRecruitSourceId: 'C2EB0000-5EA9-E0D5-F0BF-08D71FADF572',
  IdentificationTypeId: '41E62DDF-2432-4BE1-A48E-D12263C5BB58', // 证件类型
  StaffAttrTypeId: 'B28F5081-78E4-414B-8801-42C8CBB8D38D', // 员工属性
  OfficeWorkPlaceTypeId: '', // 办公职场 (等待后台提供)
  DegreeTypeId: 'B12E8C01-8272-455B-A2CD-AA51BD9C8617', // 学位类型
  RelationshipId: 'F67465C4-0354-4965-A7A9-BC5D21B1BFE4', // 与当事人关系

  // 3.4.8 新增
  BookingAduitReason_NoNeedAudit: 'FA488FFE-B71E-4480-8752-6955130E127B',
  BookingAduitReason_Less3Days: '462A8106-8700-49F7-8ED8-82B8122BB2E6',
  BookingAduitReason_DiscountBetween6And9: 'CAD0BAFA-CC0C-48E7-AFCE-A95D596FE4AB',
  BookingAduitReason_DiscountGreater9: 'DB6CBF9A-F4F7-4E33-97AF-BC612ABBD3A0',
  BookingAduitReason_DiscountLess6ButDifferenceGreater300: '36831727-C4B9-40DE-BD8E-C177E8BEBFEC',

  // 3.4.10 新增
  BookingAduitReason_DiscountLGreater6: '1A590000-3E12-0016-638C-08D91B7E9468', // 6折以上

}